import { FC } from "react";
import { ChevronDownIcon, ChevronUpIcon, MinusIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/shadcn/utils";

interface PercentageChangeTextProps {
    value: number;
    description?: string;
    valueFormatter?: (value: number) => string;
    extraClasses?: string;
}

const PercentageChangeText: FC<PercentageChangeTextProps> = ({ value, description = "", valueFormatter, extraClasses }) => {
    const formatter = valueFormatter ? valueFormatter : (value: number) => value;

    const getIcon = (value: number) => {
        if (value > 0) return ChevronUpIcon;
        if (value < 0) return ChevronDownIcon;
        return MinusIcon;
    };

    const getColorClasses = (value: number) => {
        if (value > 0) return "text-green-700";
        if (value < 0) return "text-red-500";
        return "text-gray-700";
    };

    const Icon = getIcon(value);
    const colorClasses = getColorClasses(value);

    return (
        <div className="flex items-center justify-end gap-0.5">
            <Icon className={cn("h-3 w-3", colorClasses)} />
            {value !== 0 && <span className={cn("text-sm", colorClasses, extraClasses)}>{formatter(Math.abs(value))}%</span>}
            {description && <span className="ml-2 text-sm text-muted-foreground">{description}</span>}
        </div>
    );
};

export default PercentageChangeText;
